export const getNetlifyFunctionUrl = (functionName) =>
	`/.netlify/functions/${functionName}`;
